document.addEventListener('DOMContentLoaded', () => {
    const header = document.querySelector('.site-header');
    const hamburger = document.querySelector('.hamburger-menu');
    const closeBtn = document.querySelector('.close-menu');
    const overlay = document.querySelector('.mobile-menu-overlay');
    const body = document.body;
    
    if (!header) return;

    // Determine if header started as transparent
    const isInitiallyTransparent = header.classList.contains('site-header--transparent');

    // SCROLL HANDLING
    const handleScroll = () => {
        if (!isInitiallyTransparent) return;

        if (window.scrollY > 50) {
            header.classList.add('site-header--scrolled');
            header.classList.remove('site-header--transparent');
        } else {
            header.classList.remove('site-header--scrolled');
            header.classList.add('site-header--transparent');
        }
    };

    handleScroll();
    window.addEventListener('scroll', handleScroll);

    // MOBILE MENU TOGGLE
    if (hamburger && overlay) {
        hamburger.addEventListener('click', () => {
            overlay.classList.add('active');
            header.classList.add('menu-active'); // To hide logo via CSS
            body.classList.add('menu-open');
        });
    }

    if (closeBtn && overlay) {
        closeBtn.addEventListener('click', () => {
            overlay.classList.remove('active');
            header.classList.remove('menu-active');
            body.classList.remove('menu-open');
        });
    }

    // Close on link click
    const mobileLinks = document.querySelectorAll('.mobile-menu-overlay a');
    mobileLinks.forEach(link => {
        link.addEventListener('click', () => {
            overlay.classList.remove('active');
            header.classList.remove('menu-active');
            body.classList.remove('menu-open');
        });
    });
});
